export default __webpack_public_path__ + "static/media/3-PLAYER.31731dc5.pdf";